import React from 'react';

import cx from 'classnames';

import convertMjmlStyleProps from './convertMjmlStyleProps';

import styles from './styles.scss';

export default function Mjml({
  className,
  style,
  children,
  ...otherProps
}: any) {
  return (
    <div
      className={cx(styles.Mjml, className)}
      style={{ ...style, ...convertMjmlStyleProps(otherProps) }}
    >
      {children}
    </div>
  );
}
